import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useToast } from "../../hooks/useToast";
import { AuthContext } from "../../context/authContext";
import { formattedPhone, getCountryCode } from "../../helpers/utils";
import Content from "../templates/wrapper/Content";
import SmsLoginForm from "../organisms/forms/smsLogin/SmsLoginForm";
import VerificationForm from "../organisms/forms/verification/VerificationForm";

const SmsLogin = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { t } = useTranslation();
  const { showToast } = useToast();

  const [isVerificationCodeExists, setIsVerificationCodeExists] =
    useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  const countryCode = getCountryCode();

  const handleClickVerifyWithDifferentEmail = () => {
    setIsVerificationCodeExists(false);
  };

  const handleGetCode = async ({ otp }) => {
    try {
      await authContext.answerChallenge(otp);
      showToast("success", t("otpLogin.codeSuccessConfirmCode"));
      setTimeout(() => {
        navigate(0);
      }, 3000);
    } catch (error) {
      showToast("error", t("otpLogin.smsCodeErrorConfirmCode"));
    }
  };

  const onSubmit = async (values) => {
    try {
      setPhoneNumber(values.phone_number);
      await authContext.initiateAuth(
        formattedPhone(values.phone_number, countryCode)
      );
      setIsVerificationCodeExists(true);
    } catch (error) {
      showToast("error", t("otpLogin.transactionFailed"));
      setIsVerificationCodeExists(false);
    }
  };

  const handleResend = async () => {
    try {
      await onSubmit({ phone_number: phoneNumber });
      showToast("success", t("accountVerification.successMessage"));
    } catch (error) {
      showToast("error", String(error?.message));
    }
  };

  const handleClose = () => {
    navigate("/");
  };

  return (
    <>
      <Content>
        {!isVerificationCodeExists ? (
          <SmsLoginForm countryCode={countryCode} onSubmit={onSubmit} />
        ) : (
          <VerificationForm
            title={t("accountVerification.title")}
            showRemoveOnDesktop={true}
            isPhoneNumberVerification={true}
            description={t("accountVerification.description")}
            handleGetCode={handleGetCode}
            handleResend={handleResend}
            handleClose={handleClose}
            handleClickVerifyWithDifferentEmail={
              handleClickVerifyWithDifferentEmail
            }
          />
        )}
      </Content>
    </>
  );
};

export default SmsLogin;
